    <form  class="flex flex-col gap-5 ">

        <div class="stickerList  bg-[#203A62] rounded-lg py-3 px-1 w-full">
            <div class=" max-h-36 overflow-auto">
                <div class="flex gap-3 flex-wrap justify-items-center w-full">
                    @for (sticker of stickers; track $index){
                        <div class="w-fit bg-black cursor-pointer rounded-sm" (click)="select(sticker)">
                            <img src="{{sticker.media.mediaUrl}}" alt=""  class="h-14 w-14 object-center object-contain">
                        </div>
                    }
                </div>
            </div>
        </div>
        @if (selectedStickers.length){
            <div class="flex gap-3 flex-wrap  rounded-lg py-3 px-1 w-full justify-items-center gap-y-5">
                @for (sticker of selectedStickers; track $index){
                    <div class="w-fit h-fit bg-black cursor-pointer relative ">
                        <img src="{{sticker.img}}" alt="" class="h-12 w-12 object-center object-contain">
                        @if (sticker.serviceCount > 1){
                            <div class="absolute -bottom-2 -right-2 bg-white text-red-500 flex justify-center rounded-full w-[18px] h-[18px]">
                                <span class="font-bold text-12 leading-5">
                                    {{sticker.serviceCount}}
                                </span>
                            </div>
                        }
                        <div (click)="removeSticker(sticker)" class="absolute -top-2 -right-2  flex justify-center rounded-full w-[18px] h-[18px]">
                            <span class="font-bold text-16 hover:text-red-500">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="m-auto"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="currentColor"></path></svg>
                            </span>
                        </div>
                    </div>
                }
            </div>

        }
        <div class="flex flex-col gap-3.5">
            @for (item of animationTypes; track $index){
                <button
                        (click)="selectAnimation(item)"
                        class="flex items-center px-4 py-2 rounded-lg border-primary border border-solid"
                        [ngClass]="{
                                'bg-primary': selectedAnimation === item.animation,
                                'bg-primary-disabled': stickersCount < item.stickerMinCount,
                              }"

                >
                    @if (item.name){
                        {{item.name | translate}}
                    } @else {
                        {{ item.animation| translate }}
                         {{item.stickerMinCount}} {{'pcs'| translate}} {{'sticker'| translate}}
                    }
                </button>
            }
        </div>

        <div class=" flex flex-col gap-2">
            <span class="self-center"> {{'total_amount' | translate}} {{ (Math.max(totalPrice, form.get('price')?.value ))| currency: form.get('currency')?.value }} </span>
            <a
                    (click)="donate()"
                    class=" flex w-full items-center justify-center rounded-md border border-transparent bg-primary px-8 py-3 text-base font-medium text-normal hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-primary cursor-pointer"
            >
                {{ 'donate'| translate }}
            </a>
        </div>
    </form>
